"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=14271%3A611))
 * @trackcomponent
 * @lastsynced 2026-09-30T17:16:17.000Z
 * @optimized using svgo:^3.3.4
 */
export const BSRStarFilled = createSVGIcon(
  <path
    d="m12 3.25 2.756 5.901 6.494.783-4.791 4.43 1.258 6.386L12 17.587 6.283 20.75l1.259-6.385-4.792-4.43 6.495-.784z"
    fill="currentColor"
    stroke="currentColor"
    strokeWidth="1.5"
  />,
  "BSRStarFilled",
  {
    className: iconCls(),
    color: iconColor.primary,
    fill: "none",
    viewBox: "0 0 24 24",
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
